import type { RefCallback, ReactNode } from 'react';

export interface SwipeRevealTradingCardShellProps {
  swipeRef: RefCallback<HTMLElement | null>;
  /** Klassen für die nach rechts verschiebbare Kartenfläche (inkl. Hintergrund, Border, Schatten) */
  surfaceClassName: string;
  /** Beschriftung für Screenreader auf der wischbaren Fläche */
  surfaceAriaLabel: string;
  children: ReactNode;
}

/**
 * Hintergrundschicht mit „Detail“, die links sichtbar wird, wenn die Karte per Wischgeste nach rechts verschoben wird (mobil).
 */
export function SwipeRevealTradingCardShell({
  swipeRef,
  surfaceClassName,
  surfaceAriaLabel,
  children,
}: SwipeRevealTradingCardShellProps) {
  return (
    <div className="relative overflow-hidden rounded-lg">
      <div
        className="pointer-events-none absolute inset-0 z-0 flex items-stretch bg-gradient-to-r from-blue-100 from-[28%] to-slate-100 dark:from-blue-950/80 dark:to-slate-900/90"
        aria-hidden
      >
        <div className="flex min-w-[4.5rem] max-w-[40%] flex-col items-center justify-center border-r border-blue-200/80 dark:border-blue-800/60 px-2">
          <span className="text-center text-sm font-semibold text-blue-700 dark:text-blue-300">
            Detail
          </span>
        </div>
      </div>
      <div
        ref={swipeRef}
        role="group"
        aria-label={surfaceAriaLabel}
        className={`relative z-10 ${surfaceClassName}`}
      >
        {children}
      </div>
    </div>
  );
}
